import { shallowEqual } from 'react-redux'
import { selectMemberEmails } from '../api/profiles.js'
import { useSelector } from './selector.hook.js'

/** Every member email this client has been given (userId → email); re-renders only when one is added or changes */
export const useKnownMemberEmails = () => useSelector(selectMemberEmails, shallowEqual)
